module.exports = __webpack_public_path__ + "img/logo_snowflake@2x.73d87c47.png";